import { createApi } from '@reduxjs/toolkit/query/react';
import axiosFetchBase from '../axiosFetchBase';
import { urls } from '../../utils/helpers/ApiClient';

export const evaluationFunctionsApi = createApi({
  reducerPath: 'evaluationFunctionsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  tagTypes: ['EvaluationFunction'],
  endpoints: (builder) => ({
    listEvalFunctions: builder.query({
      query: () => ({ url: urls.evaluationFunctions }),
      providesTags: (res) =>
        res
          ? [
              ...res.map(({ id }) => ({ type: 'EvaluationFunction', id })),
              { type: 'EvaluationFunction', id: 'LIST' },
            ]
          : [{ type: 'EvaluationFunction', id: 'LIST' }],
    }),
    getEvalFunction: builder.query({
      query: (id) => ({ url: urls.evaluationFunctionDetail(id) }),
      providesTags: (res, err, id) => [{ type: 'EvaluationFunction', id }],
    }),
    saveEvalFunction: builder.mutation({
      query: (req) => {
        if (req.id) {
          return {
            url: urls.evaluationFunctionDetail(req.id),
            method: 'PUT',
            data: req.body, // { name, definition }
          };
        }
        return {
          url: urls.evaluationFunctions,
          method: 'POST',
          data: req.body,
        };
      },
      invalidatesTags: [{ type: 'EvaluationFunction', id: 'LIST' }],
    }),
    deleteEvalFunction: builder.mutation({
      query: (id) => ({
        url: urls.evaluationFunctionDetail(id),
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'EvaluationFunction', id: 'LIST' }],
    }),
    runEvalFunction: builder.mutation({
      query: ({ id, ids }) => ({
        url: urls.evaluationFunctionRun(id),
        method: 'POST',
        data: ids && ids.length ? { ids } : {},
      }),
    }),
  }),
});

export const {
  useListEvalFunctionsQuery,
  useGetEvalFunctionQuery,
  useSaveEvalFunctionMutation,
  useDeleteEvalFunctionMutation,
  useRunEvalFunctionMutation,
} = evaluationFunctionsApi;
